// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1LabelSchema } from './v1/labelSchema';
import { v1LabelsCreateSchema } from './v1/labels/createSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createTagPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createTagHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Label with external_id created successfully
 */
export const createTag201Schema = z.lazy(() => v1LabelSchema);

/**
 * @description Validation failed - duplicate name
 */
export const createTag422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createTagMutationRequestSchema = z.lazy(() => v1LabelsCreateSchema);

export const createTagMutationResponseSchema = z.lazy(() => createTag201Schema);
